import React, { useRef } from 'react';
import useOnVisible from '../../hooks/useOnVisible';

import './FadeInAnimationWrapper.scss';

interface FadeInAnimationWrapperProps  {
  readonly transitionTimeSeconds?: number;
  readonly style?: React.CSSProperties;
  readonly intersectionThreshold? : number;
  children: React.ReactNode;
}

// TODO: Remove style prop when migrate the component to CSS Modules
const FadeInAnimationWrapper = ({ style, transitionTimeSeconds, children, intersectionThreshold }: FadeInAnimationWrapperProps): JSX.Element => {
  const elementRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnVisible(elementRef, intersectionThreshold);

  return (
    <div className={`__animationFadeInWrapper ${isVisible ? 'visible' : 'hidden'}`}
      ref={elementRef}
      style={{...style, transition: `all ease-in-out ${transitionTimeSeconds || 0.35}s`}}
    >
      {children}
    </div>
  );
};

export default FadeInAnimationWrapper;
